/**
 * 路由路径常量
 */

/** 首页路径 */
export const HOME_PATH = '/';
